<template>
  <div class="home-box">
    <div class="container">
      <div class="page">
        <div class="title-discover">
          <h2 class="titlesection">{{$t('home.titles.discover').toUpperCase()}}</h2>
          <h3 class="titlesection">{{$t('home.titles.discoverDescription')}}</h3>
        </div>
        <div class="player-discover">
          <video-player
            :files="[{url: '/static/img/Video-Nos-Suites.mp4', type: 'video/mp4'}, {url: '/static/img/Video-Nos-Suites.ogg', type: 'video/ogg'}]"
            cover="/static/img/Video-Nos-Suites.png" />
          <div class="stepresa">
            <div class="step">
              <img src="static/img/stepresa1.png">
              <div class="stepresa1">
                <h4><span>1. </span>{{$t('discover.step1.title').toUpperCase()}}</h4>
                <p>{{$t('discover.step1.content')}}</p>
              </div>
            </div>
            <div class="step">
              <img src="static/img/stepresa2.png">
              <div class="stepresa2">
                <h4><span>2. </span>{{$t('discover.step2.title').toUpperCase()}}</h4>
                <p>{{$t('discover.step2.content')}}</p>
              </div>
            </div>
            <div class="step">
              <img src="static/img/stepresa3.png">
              <div class="stepresa3">
                <h4><span>3. </span>{{$t('discover.step3.title').toUpperCase()}}</h4>
                <p>{{$t('discover.step3.content')}}</p>
              </div>
            </div>
            <a href="#" @click="scrollToForm" class="colored-btn red-btn"><span>{{$t('discover.button')}}</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VideoPlayer from './part/video-player';

export default {
  name: 'home-discover',
  components: { VideoPlayer },
  methods: {
    scrollToForm (e) {
      e.preventDefault();
      e.stopPropagation();
      const el = document.querySelector('.formsearch');
      if (el) {
        const opt = {top:(document.querySelector('.formsearch').offsetParent.offsetTop) - 240, left:0, behavior: "smooth"};
        window.scrollTo(opt);
        window.dispatchEvent(new CustomEvent('app:app-form:open-start-date'));
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/home-discover.vue